const lang = {
    // 登录页面
    '请输入您手机号': 'Please enter your phone number',
    '验证码': 'verification code',
    '获取验证码': 'Obtain the verification code',
    '立即登陆': 'Log in',
    '您输入的手机号有误': 'Invalid phone number',
    '您输入的验证码有误': 'Invalid verification number',
    '发送验证码成功': 'Send verification code successfully',
    '重新获取验证码': 'Reacquire captcha',
    '手机号码格式不正确': 'Incorrect format of mobile phone number',
    '登录中...': 'Logging in...',
    '为了更好的体验请横屏预览并打开屏幕自动旋转！': 'For a better experience, please preview the horizontal screen and turn on the screen to rotate automatically!',
    '注意': 'Note',
    '请开启手机方向锁，横屏体验': 'Please open the direction lock of the mobile phone to experience the horizontal screen',
    '请在微信设置-通用中开启横屏模式': 'Please turn on the horizontal screen mode in wechat settings general',
    // 首页
    '请完成上一关学习': 'Please complete the previous level',
    // 课件页面
    '上一页': 'Previous page',
    '下一页': 'Next page',
    '单元测试': 'Unit testing',
    '单页循环': 'Single page loop',
    // 练习题页面
    '提交': 'Submit',
    '答题错误': 'Answer is wrong',
    '抱歉，回答错误': 'Sorry, answer is wrong',
    '重新答题': 'Re-answer',
    '重看视频': 'Revisit video',
    '恭喜您': 'Congratulations',
    '全部关卡已通过': 'All checkpoints passed',
    '获取证书': 'Certificate',
    '返回首页': 'Back home',
    '答题正确': 'Answer is correct',
    '恭喜您本关卡已通过': 'Congratulations, passed',
    '进入下一关': 'Step into the next level',
    '请选择当前练习题答案': 'Please choose the answer to the current exercise',
    '请完成两道练习题': 'Please complete two exercises',
    // 个人中心
    '个人中心': 'Personal centre',
    '证书名称': 'Certificate Name',
    '请完成全部课程内容，获取证书': 'Please complete the entire course and obtain the certificate',
    '学习期至': 'Valid until',
    '用户姓名': 'User name',
    '请输入您的姓名': 'Please fill your name',
    '邮箱地址': 'E-mail address',
    '请输入您的邮箱地址': "Please enter your email address",
    '学校/公司': 'School/company',
    '请输入您的学校/公司名称': 'Please enter your school / company name',
    '保存': 'Save',
    '保存成功': 'Saved successfully',
    '有效期剩余': 'Validity remaining',
    '续费': 'Renewal',
    '如有疑问，请联系': 'Please email to seminar@ascms.com if any question',
    '如有疑问请打客服电话': 'If you have any questions, please call customer service',
    '查看': 'Review',
    '下载': 'Download',
    '生成': 'Generate',
    '资料填写': 'Fill in your information',
    '姓名': 'Name',
    '请填写您的姓名': 'Please fill in your name',
    '温馨提示': 'Gentle reminder',
    '您的个人中心里没有填写个人姓名，可点击姓名栏进行填写': 'Gyour personal is missing in personal center, you can click on the “name”bar to fill in',
    '注意：点击立即提交后，名字将无法修改，请注意填写': 'Note: Your name will not be changed once you click “submit”. Please fill in carefully',
    '提交成功，请前往个人中心查看下载': 'Submit successfully,please visit the Personal Center and download',
    '立即提交': 'Submit',
    '前往个人中心': 'Go to Personal Center',
    '温馨提示:请问是否用个人中心的姓名进行证书生成？“是”，请点击“立即提交”按钮，“不是”可点击姓名栏进行修改，提交后将无法修改，请注意修改': 'Gentle reminder:  would  you like to generate the certificate with the name which you filled in the personal center ? “Yes”, please click “submit” button, “no” ,  click on the “name “bar to modify, your name will not be changed once you click “submit” .Please fill in carefully',
    // 支付页
    '亲爱的用户': 'Dear user, welcome',
    '元': 'yuan',
    '天': 'day',
    '个人版': 'Personal Edition',
    '企业版': 'Enterprise Edition',
    '选择支付方式': 'Choice of payment methods',
    '支付宝/微信': 'Alipay/WeChat',
    '微信': 'WeChat',
    '支付宝': 'Alipay',
    '详情说明：个人版-个人版证书，证书只能生成一次': 'Personal Edition - Personal Edition Certificate, which can be generated only one certificate',
    '如需开票，请于7天内联系': 'Please contact us seminar@ascms.com within 7 days',
    '合计': "Total",
    '确认支付': 'Confirm payment',
    '支付详情': 'Payment details',
    '订单支付成功': 'Order paid successfully',
    '订单支付失败': 'Order payment failed',
    '您已完成支付': 'You have completed the payment',
    '请重新支付': 'Please pay again',
    '知道了': 'got it',
    '重新支付': 'Repayments',
    '支付成功，系统自动返回页面': 'If the payment is successful, the system will automatically return to the page',
    '支付成功': 'Payment successful',
    '扫一扫上方二维码进行支付': 'Scan the QR code above for payment',
    '说明详情': 'Description',
    '个人版-有效期3个月': 'Personal Edition - valid for 3 months',
    '企业版-有效期1年，共有100个学习账号，用户会收到管理后台链接、登陆账号和密码的短信，用于配置和查看学习账号。注：学习账号需配置手机号码': 'Enterprise Edition - valid for 1 year, there are 100 learning accounts. Users will receive SMS of management background link, login account and password to configure and view learning accounts. Note: mobile phone number is required for learning account',
    '有效期1年，可生成100个账号': 'Valid for 1 year, generate 100 accounts and certificates accordingly',
    '证书序号': 'Certificate No',
    '颁发日期': 'Issuance Date',
    '兹授予': 'has conferred upon',
    '成功通过认证的所有要求': 'for successfully completing the requirements of certificate'

};
export default lang;
